import logger from "../common/Logger";
import ApiService from "./ApiService";

class BotStatusService {
    constructor() {
        this.fetchBotStatus = this.fetchBotStatus.bind(this);
        this.fetchBuildOutcomes = this.fetchBuildOutcomes.bind(this);
        this.fetchLastBuildOutcome = this.fetchLastBuildOutcome.bind(this);
    }

    fetchBotStatus(callback) {
        ApiService.makeRequest('/api/bots/default/status', {
            type: 'GET',
            success: (bot) => {
                logger.info(`Bot status: ${bot.status}`);
                callback(bot);
            },
            error: (result, err) => {
                logger.error('Error fetching bot status:', err);
                callback(null, err);
            }
        })
    }

    fetchBuildOutcomes(callback) {
        ApiService.makeRequest('/api/bots/default/builds', {
            type: 'GET',
            success: (builds) => {
                logger.info(`Fetched ${builds.length} builds`);
                callback(builds);
            },
            error: (result, err) => {
                logger.error('Error fetching builds:', err);
            }
        })
    }

    fetchLastBuildOutcome(callback) {
        ApiService.makeRequest('/api/bots/default/builds/last', {
            type: 'GET',
            success: (lastBuild) => {
                logger.info(`Last build outcome: ${lastBuild.outcome}`);
                callback(lastBuild);
            },
            error: (result, err) => {
                logger.error('Error fetching last build outcome:', err);
            }
        })
    }
}

export default new BotStatusService();



// WEBPACK FOOTER //
// ./src/modules/service/BotStatusService.js